import { lazy, Suspense, StrictMode } from "react"
import {
  Route,
  Routes,
  BrowserRouter,
} from "react-router-dom"
import "focus-visible"
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ErrorBoundary as ReactErrorBoundary } from "react-error-boundary"
import ErrorBoundary from "~/components/organisms/error-boundary"
import { DndProvider } from "react-dnd"
import { HTML5Backend } from "react-dnd-html5-backend"
import { ReactFlowProvider } from "@xyflow/react"
import FullscreenLoading from "~/components/atoms/fullscreen-loading"
const NotFound = lazy(() => import("./pages/404"))
const IndexPage = lazy(() => import("./pages/root"))
const Dashboard = lazy(() => import("./pages/h"))
const LoginPage = lazy(() => import("./pages/login"))
const ResetPasswordPage = lazy(() => import("./pages/reset-password"))
const InvitePage = lazy(() => import("./pages/invite"))
const NetworkInvite = lazy(() => import("./pages/network-invite"))
const Invoice = lazy(() => import("./pages/invoice"))

const AppRoutes = () => (
  <Routes>
    <Route path="/" element={<IndexPage />} />
    <Route
      path="h/*"
      element={<Dashboard />}
    />
    <Route path="/login" element={<LoginPage />} />
    <Route path="/reset-password" element={<ResetPasswordPage />} />
    <Route path="/invite" element={<InvitePage />} />
    <Route path="/network-invite" element={<NetworkInvite />} />
    <Route path="/invoices/pdf/:id" element={<Invoice />} />
    <Route path="*" element={<NotFound/>} />
  </Routes>
)

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: false,
    },
  },
})

const App = () => (
  <StrictMode>
    <Suspense fallback={<FullscreenLoading />}>
      <ReactErrorBoundary fallbackRender={ErrorBoundary}>
        <QueryClientProvider client={queryClient}>
          <DndProvider backend={HTML5Backend}>
            <ReactFlowProvider>
              <BrowserRouter>
                <AppRoutes />
              </BrowserRouter>
            </ReactFlowProvider>
          </DndProvider>
        </QueryClientProvider>
      </ReactErrorBoundary>
    </Suspense>
  </StrictMode>
)

export default App